// PlatformLinkLine — 真實資料版（Route 15, PR #106）。
// 將 super_admin 帳號與 LINE userId 綁定。

import React, { useState } from "react";
import { Link2, CheckCircle2 } from "lucide-react";
import { Field } from "../../components/Field.js";
import { linkLineToMe, friendlyPlatformError } from "../../lib/platformApi.js";

export default function PlatformLinkLine(): React.ReactElement {
  const [lineId, setLineId] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const link = async () => {
    setBusy(true); setErr(null);
    try { await linkLineToMe(lineId.trim()); setDone(true); }
    catch (e) { setErr(friendlyPlatformError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-border bg-bg-surface p-4">
        <h2 className="text-sm font-semibold flex items-center gap-2 text-text-primary"><Link2 className="h-4 w-4 text-accent" /> 綁定我的 LINE</h2>
        <p className="text-2xs text-text-muted mt-1">把您的 LINE 帳號綁定到此 super_admin 帳號，之後可以用 LINE 收平台公告與系統警示。</p>
      </div>
      <div className="card p-4 sm:p-5 space-y-3">
        <Field label="LINE 使用者 ID" required hint="格式：U 開頭加 32 個十六進位字元；可從 LINE Developers → Messaging API → Webhook events 取得">
          <input className="input font-mono" value={lineId} onChange={(e) => setLineId(e.target.value)} placeholder="Uxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" />
        </Field>
        {err && <div className="rounded border border-danger/40 bg-danger/10 p-3 text-sm text-danger">{err}</div>}
        {done && (
          <div className="rounded border border-success/40 bg-success/10 p-3 text-sm text-success flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4" /> 綁定成功！日後系統公告會推送到此 LINE 帳號。
          </div>
        )}
        <div className="flex justify-end">
          <button className="btn-primary text-sm" onClick={() => void link()} disabled={busy || !lineId.trim()}>
            {busy ? "綁定中…" : "完成綁定"}
          </button>
        </div>
      </div>
    </div>
  );
}
